import React, {useEffect, useState} from 'react';
import YandexAdBlock from './YandexAdBlock';

// Floor Ad создан в кабинете РСЯ отдельными блоками под десктоп и под мобильные
// (форма создания блока просит платформу на выбор, а не оба сразу) — здесь просто
// подставляем нужный id по ширине экрана.
const DESKTOP_BLOCK_ID = 'R-A-20141312-1';
const MOBILE_BLOCK_ID = 'R-A-20141312-2';
const MOBILE_BREAKPOINT = 768;
// Нижний блок перерисовываем раз в 2 минуты, пока вкладка активна (правила РСЯ: не чаще раза в 30 секунд).
const REFRESH_SECONDS = 120;

const FloorAdBlock = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const blockId = isMobile ? MOBILE_BLOCK_ID : DESKTOP_BLOCK_ID;

    // Обновление: пересоздаём блок (если у AdvManager есть destroy — сначала снимаем текущий) и рисуем заново.
    // Версия API у Яндекса меняется, поэтому всё в try/catch: при ошибке блок просто остаётся как есть.
    useEffect(() => {
        const timer = setInterval(() => {
            if (document.visibilityState !== 'visible') return;
            window.yaContextCb = window.yaContextCb || [];
            window.yaContextCb.push(() => {
                try {
                    const manager = window.Ya && window.Ya.Context && window.Ya.Context.AdvManager;
                    if (!manager) return;
                    if (typeof manager.destroy === 'function') manager.destroy(blockId);
                    manager.render({blockId, type: 'floorAd', platform: isMobile ? 'touch' : 'desktop'});
                } catch (e) {
                    // обновление необязательно
                }
            });
        }, REFRESH_SECONDS * 1000);
        return () => clearInterval(timer);
    }, [blockId, isMobile]);
    // key заставляет пересоздать компонент при смене платформы (например, при
    // повороте экрана) — иначе YandexAdBlock не подхватит новый blockId, так как
    // сам рендер запускается только один раз при монтировании.
    return <YandexAdBlock key={blockId} blockId={blockId}/>;
};

export default FloorAdBlock;
